var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sortable-table',{attrs:{"table-header":_vm.tableHeader,"table-data":_vm.tableData,"page-size":_vm.getPageSize,"page-size-options":_vm.getPageSizeOptions,"max-pages":_vm.getMaxPages,"locale":_vm.getLocale,"additional-classes":_vm.additionalClasses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }